exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mgt-0{margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/views/app.category/style.scss
// module id = 364
// module chunks = 0